import i18n from '@/i18n';

const configModalEditQuickly = {
    title: i18n.t('pageCampaign.editQuickCampaign'),
    model: false,
    size: 'lg',
    footer: true,
    validate: true,
    cancelText: i18n.t('btn.cancel'),
    saveText: i18n.t('btn.save'),
    detailCampaign: null
};

const initFormEditQuickly = (data) => {
    return {
        name: data?.name ?? '',
        progress_status: data?.progress_status ?? null,
        person_in_charge_id: data?.person_in_charge_id ?? null,
        sale_staff_id: data?.sale_staff_id ?? null,
        inquiries: data?.inquiries ?? ''
    };
};

const initValidateEditQuickly = () => {
    return {
        name: {
            error: false,
            typesValidate: ['required', 'max255'],
            errorField: i18n.t('campaign.name')
        },
        progress_status: {
            trackBy: 'id',
            label: 'text',
            errorText: '',
            error: false,
            isRemove: true,
            errorField: i18n.t('tableBox.progressStatus'),
            typesValidate: ['requiredSelect']
        },
        person_in_charge_id: {
            trackBy: 'id',
            label: 'name',
            error: false,
            isRemove: false,
            errorText: '',
            errorField: i18n.t('landingPage.list.businessAssistant'),
            typesValidate: []
        },
        sale_staff_id: {
            trackBy: 'id',
            label: 'name',
            error: false,
            isRemove: false,
            errorText: '',
            errorField: i18n.t('landingPage.settingBasic.businessAssistant'),
            typesValidate: []
        },
        memo: {
            error: false,
            typesValidate: [],
            errorText: '',
            errorField: i18n.t('campaign.memo')
        },
        inquiries: {
            error: false,
            typesValidate: [],
            errorText: '',
            errorField: i18n.t('campaign.inquiries')
        }
    };
};

const initInlineEdit = (data = {}) => {
    return {
        rowId: data?.rowId ?? null,
        field: data?.field ?? null,
        value: data?.value ?? null,
        config: data?.config ?? {}
    };
};

const isEditingInline = (rowId, field, inlineEdit) => {
    return inlineEdit.rowId === rowId && inlineEdit.field === field;
};

export { configModalEditQuickly, initFormEditQuickly, initValidateEditQuickly, initInlineEdit, isEditingInline };
